import { IconProps } from '../icon';

export function FichierIcon(props: IconProps) {
  return (
    <svg
      id="Fichier"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_344"
            data-name="Rectangle 344"
            width="40"
            height="40"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_649" data-name="Groupe 649" clipPath="url(#clipPath)">
        <g id="Groupe_648" data-name="Groupe 648">
          <g id="Groupe_647" data-name="Groupe 647" clipPath="url(#clipPath)">
            <g id="Groupe_646" data-name="Groupe 646" opacity="0.5">
              <g id="Groupe_645" data-name="Groupe 645">
                <g
                  id="Groupe_644"
                  data-name="Groupe 644"
                  clipPath="url(#clipPath)"
                >
                  <path
                    id="Tracé_263"
                    data-name="Tracé 263"
                    d="M40,20A20,20,0,1,1,20,0,20,20,0,0,1,40,20"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_264"
              data-name="Tracé 264"
              d="M186.953,140.378a5.051,5.051,0,0,1-2.8-.8c-1.929-1.284-1.864-3.418-1.815-4.976.006-.21.013-.409.015-.6l.121-11.317a1.162,1.162,0,0,1,1.162-1.15h.013a1.163,1.163,0,0,1,1.15,1.175l-.121,11.317c0,.217-.009.437-.016.649-.046,1.489-.033,2.429.78,2.969a2.857,2.857,0,0,0,1.821.394c.868-.075,2.07-.664,2.07-1.575v-.042c0-.565.015-1.867.035-3.516.04-3.4.107-9.078.038-9.883-.177-2.07-2.222-3.9-4.1-4.473a6.5,6.5,0,0,0-5.929,1.226c-1.449,1.212-1.732,2.669-1.732,4.778v14.633a1.162,1.162,0,1,1-2.325,0V124.556c0-2.293.311-4.676,2.565-6.561a8.582,8.582,0,0,1,11.866.706,6.91,6.91,0,0,1,1.969,4.126c.072.848.029,5.08-.03,10.108-.019,1.576-.035,2.937-.035,3.488v.042a3.571,3.571,0,0,1-1.48,2.851,5.308,5.308,0,0,1-2.715,1.04q-.257.022-.51.022"
              transform="translate(-163.542 -108.17)"
              fill="#92b72e"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FichierIcon;
